/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Notification } from "../common/Notification";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as service from "../../store/service";
import * as common from "../../util/common";
import * as LoginActions from "../../store/loginService/actions";
import * as LoginTypes from "../../store/loginService/types";
import * as BannerMessageActions from "../../store/bannerMessage/actions";
import * as PackageServicesActions from "../../store/packageUpgradeService/actions";

import * as ConfigurationActions from "../../store/configurationService/actions";

import * as MyAccountActions from "../../store/myAccount/actions";
import { DialogComponent } from "../common/DialogComponent";
import parse from "html-react-parser";
import ProtectionPlanBillingInfo from "./protectionPlan/ProtectionPlanBillingInfo";
import EFTDialog from "./EFTDialog";
import LegalDocumentContainer from "../LegalDocumentPages/LegalDocumentContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const EZSAddFamilyMemberDialog: React.FunctionComponent<{
    closeDialog(isSuccess?: boolean): void;
    history: any;
    relationshipType: string;
    setThankYouPopUpDetails: any;
    dialogId: string;
    childFamilyMembers: any
}> = (props) => {
    const { getTermsOfUseURL, getPrivacyNoticeURL } = LegalDocumentContainer();
    const setChildSubCustomerIDToCompleteAccountSetup = (subCustomerID: string) =>
        dispatch(LoginActions.actionCreators.setChildSubCustomerIDToCompleteAccountSetup(subCustomerID));
    const setChildDOBToCompleteAccountSetup = (dob: string) => dispatch(LoginActions.actionCreators.setChildDOBToCompleteAccountSetup(dob));
    const date = new Date();
    const year = parseInt(date.getFullYear().toString());
    let yearList: number[] = [];
    for (let i = year; i <= year + 10; i++) {
        yearList.push(i);
    }
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, props.history, familyMembers));
    const setRedirectToDashboard = (forceUpdate: boolean) => dispatch(ConfigurationActions.actionCreators.setRedirectToDashboard(forceUpdate));
    const isCCAMActive = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo?.hasCCAM ? true : false));
    const packageServicesAction = () => dispatch(PackageServicesActions.actionCreators.requestPackageData());
    const requestBannerMessage = () => dispatch(BannerMessageActions.actionCreators.getBannerAlertMessage(true));
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const updateFamilyMember = (familyMembers: any) => dispatch(LoginActions.actionCreators.updateFamilyMember(familyMembers));
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(true));
    const [negativeAgeError, setNegativeError] = useState(false);
    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const maximumChildAge = familyOffer && familyOffer.familyChildOffer?.childAgeLimit ? familyOffer.familyChildOffer?.childAgeLimit : 18;
    const minimumMemberAge = 18;
    const isHouseholdMember = props.relationshipType === "Family Plan Adult" ? true : false;
    const isChildMember = props.relationshipType === "Family Plan Child" ? true : false;
    const { t: tLang } = useTranslation();
    const packageInformationData = useSelector((state: ApplicationState) =>
        state?.protectionPlanState?.protectionPlanData?.packageList ? state?.protectionPlanState?.protectionPlanData?.packageList : []
    );
    const activePackage = packageInformationData ? packageInformationData.find((x) => x.IsActive === true) : null;
    const [step, setStep] = useState(1);
    const [EFTdialog, setEFTDialog] = useState(false);
    const [state, setState] = useState<any>({ EFTData: [], isEFTChecked: false });
    const [loadingPaymentInfo, setLoadingPaymentInfo] = useState(false);
    const [loadingPaymentDetails, setloadingPaymentDetails] = useState(false);
    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const [billingInfoChanged, setBillingInfoChanged] = useState(false);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const SetIsBillingInfoChangedStatus = (status: boolean) => dispatch(MyAccountActions.actionCreators.SetIsBillingInfoChangedStatus(status));
    const [familyAccountList, setFamilyAccountList] = useState([{ firstName: "", lastName: "", dateOfBirth: "", relationship: props.relationshipType, email: "" }]);
    const [isRemoving, setIsRemoving] = useState(false);
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const getAgeLimit = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.ageLimit ? state.loggedInUser.ageLimit : null));
    const householdMembers = familyMembers.filter((x) => x.accountType === "Family Plan Adult")
        ? familyMembers.filter((x) => x.accountType === "Family Plan Adult")
        : [];

    const partnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const isPartnerIdIsGoezshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 36
                ? true
                : false
            : false
    );

    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel === "Terms of Use"
                ? tLang("pageFooter.termsOfUse")
                : state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : tLang("pageFooter.termsOfUse")
    );
    const privacyPolicyLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel === "Privacy Notice"
                ? tLang("pageFooter.privacyNotice")
                : state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            : tLang("pageFooter.privacyPolicy")
    );

    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );

    const retailerTollFreeNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerTollFreeNumber
            ? state.configurationState.configuration.partnerConfig.retailerTollFreeNumber
            : ""
    );
    const [paymentDetail, setPaymentDetail] = useState({
        familyProtectionCharge: 0,
        countOfUserPaidFamilyMembers: 0,
        totalCost: 0,
        removeFamilyProtectionCost: 0,
        familyProtectionCostPerMember: 0,
        newChargeWithFamilyProtection: 0,
        packagePrice: 0,
        billingText: "",
        packageId: 0,
        subscriptionType: "monthly",
        newCharge: 0,
        todaysNetCharge: 0,
        tax: 0.0,
        billingCycleDescription1: "",
        billingCycleDescription2: "",
        billingCycleDescription3: "",
        currentMonthlyCharge: 0,
        difference: 0,
        newMonthlyChargeStartFrom: "",
        creditedAmount: 0,
        refundAmount: 0,
        isSuccess: true,
        hasError: false,
        errors: [],
    });
    const [isDuplicateEmailError, setIsDuplicateEmailError] = useState(false);
    const [duplicateEmail, setDuplicateEmail] = useState("");

    const [paymentInfoState, setPaymentInfoState] = useState({
        name: "",
        cardOrAccNumber: "",
        exp: "",
        paymentMethod: "",
        address: {
            addressline1: "",
            addressline2: "",
            city: "",
            state: "",
            zipCode: "",
            country: "",
        },
    });
    const [disableButton, setDisableButton] = useState(true);
    const maxAgeLimit = getAgeLimit ? getAgeLimit.maxAgeLimit : "";
    const minAgeLimit = getAgeLimit ? getAgeLimit.minAgeLimit : "";
    const { register, errors, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });
    
    const [proofInfo, setProofInfo] = useState({
        checkBoxAcceptance: "",
        continueButtonAcceptance: ""
    });

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    }, []);

    useEffect(() => {
        if (isHouseholdMember && familyOffer?.familyAdultOffer?.isUserPaid && step === 2) {
            getPayAsYouGoAmountDetails();
        }
    }, [paymentInfoState]);

    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            SetIsBillingInfoChangedStatus(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            if (isHouseholdMember && familyOffer?.familyAdultOffer?.isUserPaid) {
                getPaymentDetailsData();
            }
            SetIsBillingInfoChangedStatus(true);
        }
    };
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };
    const storeTimestampCheckbox = (): any => {
        let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
        setProofInfo({ ...proofInfo, checkBoxAcceptance: prooftime });
    };
    const storeTimestampContinueButton = (): any => {
        let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
        setProofInfo({ ...proofInfo, continueButtonAcceptance: prooftime });
    };

    const getPaymentDetailsData = () => {
        setLoadingPaymentInfo(true);
        service
            .GetPaymentDetail()
            .then((data) => {
                setLoadingPaymentInfo(false);

                if (data.billingAddress !== null) {
                    const billing = data.billingAddress;
                    if (data.creditCard !== null && data.creditCard.cardNumber !== null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.creditCard.cardNumber,
                            name: data.creditCard.nameOnCard,
                            exp: data.creditCard.expDateMo + "/" + data.creditCard.expDateYr,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state.selection,
                                zipCode: billing.zipCode,
                                country: billing.country,
                            },
                        });
                    } else if (data.eft !== null && data.eft.accountNumber !== null) {
                        setPaymentInfoState({
                            ...paymentInfoState,
                            cardOrAccNumber: data.eft.accountNumber,
                            name: data.eft.nameOnAccount,
                            paymentMethod: data.paymentMethod?.selection,
                            address: {
                                addressline1: billing.address1,
                                addressline2: billing.address2,
                                city: billing.city,
                                state: billing.state?.selection,
                                zipCode: billing.zipCode,
                                country: billing.country,
                            },
                        });
                        service.getEFTInfo().then((res: any) => {
                            setState({ ...state, EFTData: res });
                        });
                    }
                } else {
                    getPayAsYouGoAmountDetails();
                }
            })
            .catch(() => {
                Notification({
                    type: "error",
                    title: `Get Card Information Error`,
                    message: `Something went wrong, Please try again.`,
                });
                setLoadingPaymentInfo(false);
            });
    };

    const closeDialog = (isSuccess?: boolean) => {
        document.body.classList.remove("no_scroll");
        props.closeDialog(isSuccess);
    };

    const refreshFamilyMembersInformation = () => {
        setisLoading(false);
        getFamilyMembers();
        closeDialog();
    };

    let birthDateFieldPressedKey: number;
    const updatBirthDatePressedKey = (e: any) => {
        birthDateFieldPressedKey = e.keyCode;
    };

    function onChangeHandler(event: any, index: any) {
        const elName = event.currentTarget.name;
        const name = elName.split("-")[0] as string;
        const familyAccounts = [...familyAccountList];
        const familyAccount = { ...familyAccounts[index] } as any;
        familyAccount[name] = event.currentTarget.value;
        familyAccounts[index] = familyAccount;
        setFamilyAccountList([...familyAccounts]);

        if (name === "dateOfBirth") {
            if ((event.target.value.length === 2 || event.target.value.length === 5) && birthDateFieldPressedKey !== 8 && birthDateFieldPressedKey !== 46) {
                event.target.value = event.target.value + "/";
            }
            if (!isHouseholdMember) {
                checkMemberAge(event.currentTarget.value);
            }
        }
    }

    const switchUserAccount = (userData: any) => {
        requestAccountSwitch(userData["subcustomerId"], userData);
    };

    const requestAccountSwitch = (subcustomerID: string, accountToSwitch: any) => {
        const requestBody = { SubcustomerId: subcustomerID };
        service.switchFamilyAccount(requestBody).then((data) => {
            if (!data["hasError"] && data["familyMembers"]) {
                if (accountToSwitch) {
                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);

                    const path = window.location.pathname;
                    if (path.toLowerCase().endsWith("dashboard")) {
                        setRedirectToDashboard(true);
                        props.history.push("/switch-account");
                    }

                    packageServicesAction();
                    requestBannerMessage();
                }
            }
        });
    };

    const postSumbitPrecess = (data: any) => {
        if (!data["has-error"]) {
            Notification({
                type: "success",
                title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.addHouseholdMemberText") : tLang("manageAccount.myAccount.familyProtection.addChildMemberText"),
                message: familyAccountList[0].firstName + " " + familyAccountList[0].lastName + " " + tLang("manageAccount.myAccount.familyProtection.addedSuccessfullyText") + ".",
                duration: 5,
            });
            if (props.relationshipType === "Family Plan Child") {
                let idSubCustomer = "";
                if (data["family-add-members"] && data["family-add-members"].length > 0 && data["family-add-members"][0]["id-sub-customer"]) {
                    idSubCustomer = data["family-add-members"][0]["id-sub-customer"];
                }
                if (idSubCustomer) {
                    service
                        .getUserFamily()
                        .then((data: any) => {
                            updateFamilyMember(data["familyMembers"]);
                            if (!data["hasError"] && data["familyMembers"]) {
                                updateFamilyMember(data["familyMembers"]);
                                setChildSubCustomerIDToCompleteAccountSetup(idSubCustomer);
                                const userData: any = data["familyMembers"].find((x: any) => x.subcustomerId === idSubCustomer);
                                if (isCCAMActive && userData) {
                                    switchUserAccount(userData);
                                } else {
                                    props.history.push("/complete-family-setup");
                                }
                            }
                            setisLoading(false);
                        })
                        .catch(() => {
                            setisLoading(false);
                            refreshFamilyMembersInformation();
                        });
                } else {
                    refreshFamilyMembersInformation();
                }
            } else {
                refreshFamilyMembersInformation();
            }
        } else {
            Notification({
                type: "error",
                title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsgHeading"),
                message: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsg") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsg")
            });
            setisLoading(false);
        }
    };

    const getPayAsYouGoAmountDetails = () => {
        const requestBody = {
            isUserPaidAdultFamilyMembers: true,
            numberOfNewFamilyMemberAdded: familyAccountList ? familyAccountList.length : 1,
            isRemoveFamilyRequest: false,
            subAccountPk_For_Remove: "",
            billingChargeInformation: {
                packageId: activePackage?.PackagId,
                packageCode: activePackage?.PackageCode,
                packagePrice: activePackage?.SubcriptionType.toLowerCase() === "yearly" ? activePackage?.PackagePriceYearly : activePackage?.PackagePrice,
                changeType: "PURCHASE",
                subscriptionType: activePackage?.SubcriptionType,
                street1: paymentInfoState?.address?.addressline1 ? paymentInfoState.address.addressline1 : accountInfo?.address1,
                street2: paymentInfoState?.address?.addressline2 ? paymentInfoState.address.addressline2 : accountInfo?.address2,
                city: paymentInfoState?.address?.city ? paymentInfoState.address.city : accountInfo?.city,
                country: paymentInfoState?.address?.country ? paymentInfoState.address.country : accountInfo?.country ? accountInfo.country : "US",
                isAvalaraTaxCalculation: true,
                enrollmentType: "PROVISIONAL",
                region: paymentInfoState?.address?.state ? paymentInfoState.address.state : accountInfo?.state,
                postalCode: paymentInfoState.address.zipCode ? paymentInfoState.address.zipCode : accountInfo?.zipCode,
            },
            packageId: activePackage?.PackagId,
        };
        setloadingPaymentDetails(true);
        service
            .getPayAsYouGoAmountDetails(requestBody)
            .then((data) => {
                if (data.isSuccess) {
                    setPaymentDetail(data);
                } else {
                    Notification({
                        type: "error",
                        title: `Get Payment Details Error`,
                        message: `Something went wrong, Please try again.`,
                    });
                }
                setloadingPaymentDetails(false);
            })
            .catch(() => {
                setloadingPaymentDetails(false);
            });
    };

    const addFamilyMember = () => {
        if (!negativeAgeError) {
            if (isHouseholdMember && familyOffer?.familyAdultOffer?.isUserPaid) {
                if (step === 1) {
                    setIsDuplicateEmailError(false);
                    for (let acc of familyAccountList) {
                        if (acc.email && duplicateEmailCheck(acc.email)) {
                            setDuplicateEmail(acc.email);
                            setIsDuplicateEmailError(true);
                            return;
                        }
                    }
                    if (isDuplicateEmailError === false) {
                        setStep(2);
                        getPaymentDetailsData();
                    }
                } else if (step === 2) {
                    if(paymentInfoState.paymentMethod !== "EFT"){
                        service.getPayementProfileValidity({"payAsYouGoBillingChargeInfoResponse": paymentDetail})
                            .then((data)=>{if(data.creditCardValidateResponse['nativeResponseMessage'].toLowerCase() === 'approved' && data.creditCardValidateResponse['addressVerifyResult'] === 5){
                                addUserPaidFamilyPlanMember();
                            }else{
                                Notification({
                                    type: "error",
                                    title: `Billing Information`,
                                    message: `Address is invalid.`,
                                });
                            }
                        });
                    }else{
                        addUserPaidFamilyPlanMember();
                    }
                }
            } else {
                addFamilyPlanMember();
            }
        }
    };

    const addFamilyPlanMember = () => {
        setisLoading(true);
        setChildDOBToCompleteAccountSetup("");
        if (familyAccountList.length > 0 && familyAccountList[0].dateOfBirth !== null && familyAccountList[0].dateOfBirth !== "") {
            const requestBody = {
                "family-members": [
                    {
                        "account-type": isHouseholdMember && getAgeLimit ? "Family Plan Young Adult" : familyAccountList[0].relationship,
                        "first-name": familyAccountList[0].firstName,
                        "last-name": familyAccountList[0].lastName,
                        email: familyAccountList[0].email,
                        "date-of-birth": familyAccountList[0].dateOfBirth,
                    },
                ],
            };
            service
                .addFamilyPlanMember(requestBody)
                .then((data) => {
                    if (isCCAMActive && !isHouseholdMember) {
                        service.getUserFamily().then((userFamilyData: any) => {
                            updateFamilyMember(userFamilyData["familyMembers"]);
                            const newUserData: any = userFamilyData["familyMembers"].find(
                                (x: any) => x.subcustomerId === data["family-add-members"][0]["id-sub-customer"]
                            );
                            const completeChildSetupPayload = {
                                ChildEmailAddress: newUserData?.email,
                                asset: {
                                    personalInformation: {
                                        "first-name": familyAccountList[0].firstName,
                                        "last-name": familyAccountList[0].lastName,
                                        "primary-email-address": { email: null, "monitor-id": null, "record-id": null },
                                        "additional-emails-address": [],
                                        "primary-phone": { phone: null, "monitor-id": null, "record-id": null },
                                        "additional-phone": [],
                                        "date-of-birth": familyAccountList[0].dateOfBirth,
                                    },
                                },
                            };
                            service
                                .completeAccountSetupEZS(completeChildSetupPayload)
                                .then((responseData) => {
                                    postSumbitPrecess(data);
                                })
                                .catch((err: any) => {});
                        });
                    }
                    setChildDOBToCompleteAccountSetup(familyAccountList[0].dateOfBirth);
                    if (isHouseholdMember || !isCCAMActive) {
                        postSumbitPrecess(data);
                    }
                })
                .catch(() => {
                    refreshFamilyMembersInformation();
                    Notification({
                        type: "error",
                        title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsgHeading"),
                        message: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsg") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsg"),
                    });
                    setisLoading(false);
                });
        } else {
            Notification({
                type: "error",
                title: tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsgHeading"),
                message: `Date Of Birth address can not be empty.`,
            });
            setisLoading(false);
        }
    };

    const addUserPaidFamilyPlanMember = () => {
        let accounts = [];
        for (let acc of familyAccountList) {
            accounts.push({
                ezShieldId: "",
                nukeUserId: 0,
                subscriberProfileID: "",
                provisionalID: "",
                idfUserID: "",
                accountTypeTitle: props.relationshipType,
                accountTypeDescription: "Family Plan Adult",
                firstName: acc.firstName,
                lastName: acc.lastName,
                dob: acc.dateOfBirth,
                email: acc.email,
                registrationStatus: false,
                subAccountPk: "",
                setUpCompleteDate: "",
                currentSubscriptionType: activePackage?.SubcriptionType ? activePackage?.SubcriptionType : "monthly",
                price: familyOffer?.familyAdultOffer?.payAsYouGoMonthlyPrice ? Number(familyOffer.familyAdultOffer.payAsYouGoMonthlyPrice?.toFixed(2)) : 0.0,
            });
        }

        setisLoading(true);
        const requestBody = {
            payAsYouGoBillingChargeInfoDetails: paymentDetail,
            familySubAccounts: accounts,
            automaticRenewal: proofInfo.checkBoxAcceptance,
            automaticRenewalAcceptance: proofInfo.continueButtonAcceptance,
        };
        service
            .addUserPaidFamilyPlanMember(requestBody)
            .then((data) => {
                setisLoading(false);

                if (!data["hasError"]) {
                    getFamilyMembers();
                    const responseData = data?.userPaidFamilyMultipleSubAccountDetails?.payAsYouGoBillingChargeInfoDetails;

                    const thankYoupoPopDetails = {
                        planCost: responseData.packagePrice,
                        totalCost: responseData.totalCost,
                        tax: responseData.tax,
                        familyProtectionCharge: responseData.familyProtectionCharge,
                        newCharge: responseData.todaysNetCharge,
                        message: responseData.billingText,
                        adultCount: paymentDetail.countOfUserPaidFamilyMembers,
                    };
                    props.setThankYouPopUpDetails(thankYoupoPopDetails);
                    closeDialog(true);
                } else {
                    Notification({
                        type: "error",
                        title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsgHeading"),
                        message: data["errors"][0],
                    });
                    closeDialog(false);
                }
            })
            .catch((ex) => {
                refreshFamilyMembersInformation();
                Notification({
                    type: "error",
                    title: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsgHeading") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsgHeading"),
                    message: isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.toastMsgs.addHouseHoldMember.errorMsg") : tLang("manageAccount.myAccount.familyProtection.toastMsgs.addChildMember.errorMsg")
                });
                setisLoading(false);
            });
    };

    const checkMemberAge = (date: string) => {
        try {
            const accountDOBinDateFormate = new Date(date);
            const todaysDate = new Date();

            if (todaysDate < accountDOBinDateFormate) {
                setNegativeError(true);
            } else {
                setNegativeError(false);
            }
        } catch {
            setNegativeError(false);
        }
    };

    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };

    const checked = () => {
        if (state.isEFTChecked) {
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    const getSubscriptionType = () => {
        let subscriptionType = "Monthly";
        if (activePackage && activePackage.SubcriptionType) {
            subscriptionType = activePackage.SubcriptionType;
        }
        return subscriptionType?.toUpperCase();
    };

    const duplicateEmailCheck = (email: string): boolean => {
        let isDuplicate = false;
        try {
            const accountCount = familyAccountList.filter((acc) => acc.email === email).length;
            if (accountCount > 1) {
                isDuplicate = true;
            }
        } catch {}
        return isDuplicate;
    };
    const toggleDisableButton = () => {
        setDisableButton(!disableButton);
    };

    const openTermsOfUsePage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (termsOfUseLegalDocumentLink) {
            const urlToOpen = termsOfUseLegalDocumentLink.startsWith("/") ? base_url + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/terms";
    };

    const openPrivacyPolicyPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (privacyPolicyLegalDocumentLink) {
            const urlToOpen = privacyPolicyLegalDocumentLink.startsWith("/") ? base_url + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
            return urlToOpen;
        }

        return base_url + "/privacy";
    };
    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-user-plus"></em>
                        </div>
                        <h1> {isHouseholdMember ? tLang("manageAccount.myAccount.familyProtection.addHouseholdMemberText")  :  tLang("manageAccount.myAccount.familyProtection.addChildMemberText")}</h1>
                        {isChildMember && (
                            <div>
                                <p>
                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.attestationStatement2")}
                                </p>
                                <h4>{tLang("dashboard.addFamilyMemberDialog.childwatch.attestationFormHeading")}</h4>
                                <p>{tLang("dashboard.addFamilyMemberDialog.childwatch.attestationFormContent")}&nbsp;
                                    {isPartnerIdIsGoezshield ?
                                        (
                                            <>
                                                <a
                                                    href={openTermsOfUsePage()}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Terms of Use" });
                                                    }}
                                                >
                                                    <span className="nav-text">{tLang("PageFooter.label3")}</span>
                                                </a>&nbsp;
                                                {tLang("dashboard.addFamilyMemberDialog.childwatch.andText")}&nbsp;
                                                <a
                                                    href="https://www.sontiq.com/privacy-policy/"
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    <span className="nav-text">{tLang("PageFooter.label4")}</span>
                                                </a>.
                                            </>
                                        ) :
                                        (
                                            <>
                                                <a
                                                    href={openTermsOfUsePage()}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Terms of Use" });
                                                    }}
                                                >
                                                    <span className="nav-text">{termsOfUseLegalDocumentLabel}</span>
                                                </a>&nbsp;
                                                {tLang("dashboard.addFamilyMemberDialog.childwatch.andText")}&nbsp;
                                                <a
                                                    href={openPrivacyPolicyPage()}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Privacy Policy" });
                                                    }}
                                                >
                                                    <span className="nav-text">{privacyPolicyLegalDocumentLabel}</span>
                                                </a>.
                                            </>
                                        )
                                    }
                                </p>
                            </div>
                        ) }
                    </div>
                    {step === 1 && (
                        <>
                            {!isRemoving && (
                                <form onSubmit={handleSubmit(addFamilyMember)} id="add-ezs-family.member-form-container">
                                    <div className="dialog-body">
                                        {familyAccountList &&
                                            familyAccountList.length > 0 &&
                                            familyAccountList.map((familyAccount, index) => {
                                                return (
                                                    <div key={`add-ezs-family-member-${index}`}>
                                                        {index > 0 && (
                                                            <div role="grid" className="data-grid has-lines row-height-md margin-top-s margin-bottom-s"></div>
                                                        )}
                                                        {isChildMember && (
                                                            <h4>
                                                                {tLang("dashboard.addFamilyMemberDialog.childwatch.addChildText")}&nbsp;
                                                                {props.childFamilyMembers?.length + 1}&nbsp;
                                                                {tLang("dashboard.addFamilyMemberDialog.childwatch.ofText")}&nbsp;
                                                                {familyOffer?.familyChildOffer?.childMaxLimit}&nbsp;
                                                            </h4>
                                                        )}
                                                        <div className={errors[`firstName-${index}`] ? "form-row row status-error" : "form-row row"}>
                                                            <div className="form-row inline row">
                                                                <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                                    <label htmlFor={`add-first-name-${index}`}>
                                                                        {tLang("dashboard.addFamilyMemberDialog.firstname")}{" "}
                                                                        <span className="required" title="Mandatory">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                                <div className="inline row">
                                                                    <div className="form-input col-xs-10 col-sm-10 col-no-gutter">
                                                                        <input
                                                                            type="text"
                                                                            className={errors[`firstName-${index}`] ? "status-error inputbox" : "inputbox"}
                                                                            id={`add-first-name-${index}`}
                                                                            name={`firstName-${index}`}
                                                                            defaultValue={familyAccount.firstName ? familyAccount.firstName : ""}
                                                                            onChange={(e) => onChangeHandler(e, index)}
                                                                            ref={register({
                                                                                required: true,
                                                                                pattern: PATTERNS.FIRSTNAME_ADD_CHILD.pattern,
                                                                            })}
                                                                            maxLength={30}
                                                                            aria-required="true"
                                                                        />

                                                                        {errors[`firstName-${index}`] && errors[`firstName-${index}`].type === "pattern" && (
                                                                            <span className="form-error">{tLang(PATTERNS.FIRSTNAME_ADD_CHILD.message)}</span>
                                                                        )}
                                                                        {errors[`firstName-${index}`] && errors[`firstName-${index}`].type === "required" && (
                                                                            <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.firstname.required")}</span>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-input col-xs-2 col-sm-2 col-no-gutter">
                                                                        {index > 0 && (
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    setIsRemoving(true);
                                                                                    const list = [...familyAccountList];
                                                                                    list.splice(index, 1);
                                                                                    setFamilyAccountList(list);
                                                                                    setTimeout(() => {
                                                                                        setIsRemoving(false);
                                                                                    }, 50);
                                                                                }}
                                                                                className="btn-default btn-secondary-outline btn-icon-only btn-no-border btn-no-padding la-pull-right"
                                                                            >
                                                                                <span className="btn-icon">
                                                                                    <em className="las la-trash-alt"></em>
                                                                                </span>
                                                                                <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.removeFamilyMember")}</span>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className={errors[`lastName-${index}`] ? "form-row row status-error" : "form-row row"}>
                                                            <div className="form-row inline row">
                                                                <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                                    <label htmlFor={`edit-last-name-${index}`}>
                                                                        {tLang("dashboard.addFamilyMemberDialog.lastname")}{" "}
                                                                        <span className="required" title="Mandatory">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                                <div className="inline row">
                                                                    <div className="form-input col-xs-10 col-sm-10 col-no-gutter">
                                                                        <input
                                                                            type="text"
                                                                            className="inputbox"
                                                                            id={`edit-last-name-${index}`}
                                                                            name={`lastName-${index}`}
                                                                            defaultValue={familyAccount.lastName ? familyAccount.lastName : ""}
                                                                            onChange={(e) => onChangeHandler(e, index)}
                                                                            ref={register({
                                                                                required: true,
                                                                                pattern: PATTERNS.LASTNAME_ADD_CHILD.pattern,
                                                                            })}
                                                                            maxLength={30}
                                                                            aria-required="true"
                                                                        />
                                                                        {errors[`lastName-${index}`] && errors[`lastName-${index}`].type === "pattern" && (
                                                                            <span className="form-error">{tLang(PATTERNS.LASTNAME_ADD_CHILD.message)}</span>
                                                                        )}

                                                                        {errors[`lastName-${index}`] && errors[`lastName-${index}`].type === "required" && (
                                                                            <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.lastname.required")}</span>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-input col-xs-2 col-sm-2 col-no-gutter"></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div
                                                            className={
                                                                errors[`dateOfBirth-${index}`] || negativeAgeError ? "form-row row status-error" : "form-row row"
                                                            }
                                                        >
                                                            <div className="form-row inline row">
                                                                <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                                    <label htmlFor={`edit-dateOfBirth-${index}`}>
                                                                        {tLang("dashboard.addFamilyMemberDialog.dob")}{" "}
                                                                        <span className="required" title="Mandatory">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                                <div className="inline row">
                                                                    <div className="form-input col-xs-10 col-sm-10 col-no-gutter">
                                                                        <input
                                                                            type="text"
                                                                            className="inputbox"
                                                                            id={`edit-dateOfBirth-${index}`}
                                                                            placeholder="MM/DD/YYYY"
                                                                            name={`dateOfBirth-${index}`}
                                                                            defaultValue={familyAccount.dateOfBirth ? familyAccount.dateOfBirth : ""}
                                                                            onKeyDown={updatBirthDatePressedKey}
                                                                            onChange={(e) => onChangeHandler(e, index)}
                                                                            aria-required="true"
                                                                            ref={register({
                                                                                required: true,
                                                                                //validate: validateAge,
                                                                                pattern:
                                                                                    /^(([0][1-9]|1[012])[/]([0][1-9]|[12][0-9]|3[01])[/](18|19|20|21)?[0-9]{4})*$/,
                                                                                validate: (value) => {
                                                                                    try {
                                                                                        const accountDOBinDateFormate = new Date(value);
                                                                                        const age = common.calculate_age(accountDOBinDateFormate);
                                                                                        if (isHouseholdMember && maxAgeLimit && minAgeLimit) {
                                                                                            const ageInDecimal =
                                                                                                common.calculateAgeInDecimal(accountDOBinDateFormate);

                                                                                            return (
                                                                                                Number(ageInDecimal) >= Number(minAgeLimit) &&
                                                                                                Number(ageInDecimal) <= Number(maxAgeLimit) - 1
                                                                                            );
                                                                                        }
                                                                                        //adding equals condition between age & minimumMemberAge so that it can take 18 yr as valid age
                                                                                        return isHouseholdMember ? age >= minimumMemberAge : age < maximumChildAge;
                                                                                    } catch {
                                                                                        return false;
                                                                                    }
                                                                                },
                                                                            })}
                                                                            maxLength={10}
                                                                        />
                                                                        {errors[`dateOfBirth-${index}`] && errors[`dateOfBirth-${index}`].type === "pattern" && (
                                                                            <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.pattern")}</span>
                                                                        )}

                                                                        {errors[`dateOfBirth-${index}`] && errors[`dateOfBirth-${index}`].type === "required" && (
                                                                            <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.required")}</span>
                                                                        )}

                                                                        {!isHouseholdMember &&
                                                                            errors[`dateOfBirth-${index}`] &&
                                                                            errors[`dateOfBirth-${index}`].type === "validate" && (
                                                                                <span className="form-error">
                                                                                {tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.under18", { maximumChildAge: maximumChildAge })}
                                                                                </span>
                                                                            )}

                                                                        {isHouseholdMember &&
                                                                            !getAgeLimit &&
                                                                            errors[`dateOfBirth-${index}`] &&
                                                                            errors[`dateOfBirth-${index}`].type === "validate" && (
                                                                            <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.above18")}</span>
                                                                            )}
                                                                        {isHouseholdMember &&
                                                                            errors[`dateOfBirth-${index}`] &&
                                                                            errors[`dateOfBirth-${index}`].type === "validate" &&
                                                                            getAgeLimit && (
                                                                                <span className="form-error">
                                                                                    {tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.between18and25")}
                                                                                </span>
                                                                            )}

                                                                        {negativeAgeError && !isHouseholdMember && (
                                                                            <span className="form-error">
                                                                                {tLang("manageAccount.myAccount.familyProtection.validationMsgs.dob.futureDate")}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="form-input col-xs-2 col-sm-2 col-no-gutter"></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {isHouseholdMember && (
                                                            <div className={errors[`email-${index}`] ? "form-row row status-error" : "form-row row"}>
                                                                <div className="form-row inline row">
                                                                    <div className="form-label col-xs-12 col-sm-6 col-no-gutter">
                                                                        <label htmlFor={`edit-email-${index}`}>
                                                                            {tLang("dashboard.addFamilyMemberDialog.email")}{" "}
                                                                            <span className="required" title="Mandatory">
                                                                                *
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="inline row">
                                                                        <div className="form-input col-xs-10 col-sm-10 col-no-gutter">
                                                                            <input
                                                                                type="text"
                                                                                className="inputbox"
                                                                                id={`edit-email-${index}`}
                                                                                name={`email-${index}`}
                                                                                defaultValue={familyAccount.email ? familyAccount.email : ""}
                                                                                onChange={(e) => onChangeHandler(e, index)}
                                                                                ref={register({
                                                                                    required: true,
                                                                                    pattern: PATTERNS.EMAIL.pattern,
                                                                                })}
                                                                                maxLength={PATTERNS.EMAIL.maxLength}
                                                                                aria-required="true"
                                                                            />
                                                                            {errors[`email-${index}`] && errors[`email-${index}`].type === "pattern" && (
                                                                                <span className="form-error">{tLang(PATTERNS.EMAIL.message)}</span>
                                                                            )}

                                                                            {errors[`email-${index}`] && errors[`email-${index}`].type === "required" && (
                                                                                <span className="form-error">{tLang("manageAccount.myAccount.familyProtection.validationMsgs.email.required")}</span>
                                                                            )}
                                                                        </div>
                                                                        <div className="form-input col-xs-2 col-sm-2 col-no-gutter"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        {isHouseholdMember &&
                                            householdMembers &&
                                            familyAccountList &&
                                            familyOffer &&
                                            familyOffer.familyAdultOffer?.isUserPaid &&
                                            familyOffer?.familyAdultOffer?.adultMaxLimit &&
                                            (familyOffer?.familyAdultOffer?.adultMaxLimit === 0 ||
                                                householdMembers.length + familyAccountList.length < familyOffer?.familyAdultOffer?.adultMaxLimit) && (
                                                <>
                                                    <div className="margin-top-l"></div>
                                                    <p>
                                                        {" "}
                                                        <a
                                                            onClick={() => {
                                                                setFamilyAccountList([
                                                                    ...familyAccountList,
                                                                    {
                                                                        firstName: "",
                                                                        lastName: "",
                                                                        dateOfBirth: "",
                                                                        relationship: props.relationshipType,
                                                                        email: "",
                                                                    },
                                                                ]);
                                                            }}
                                                            role="menuitem"
                                                            href="javascript:void(0);"
                                                            className="default_link"
                                                        >
                                                            <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addAnotherFamilyMember")}
                                                        </a>
                                                    </p>
                                                </>
                                            )}
                                        {isDuplicateEmailError && (
                                            <>
                                                <div className="margin-top-l"></div>
                                                <span className="form-error">
                                                    <strong>{duplicateEmail}</strong>{" "} {tLang("manageAccount.myAccount.familyProtection.validationMsgs.email.duplicate")}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                    <div className="dialog-footer">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.cancelBtnText")}</span>
                                                </button>
                                            </div>
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <button type="submit" className="btn-default btn-primary">
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.familyProtection.continueBtnText")}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </>
                    )}
                    {step === 2 && (
                        <React.Fragment>
                            <form id="protection-plan-upgrade-form-container" onSubmit={handleSubmit(addFamilyMember)}>
                                <div className="dialog-body">
                                    <div className="form-row">
                                        <h3 className="content-sub-title">Your Cart Summary</h3>
                                    </div>
                                    <div className="line-divider margin-vertical-xs"></div>

                                    <div className="form-row data-grid has-lines row-height-sm">
                                        <fieldset className="form-row inline">
                                            <div className="row data-row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-payment-info">
                                                        <p>
                                                            <strong>Payment Information</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className={"col-xs-12 col-sm-8 col-no-gutter " + (loadingPaymentInfo ? "loading" : "")}>
                                                    <div className="data-value" aria-labelledby="label-payment-info">
                                                        <div className="row between-xs">
                                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                                {paymentInfoState.cardOrAccNumber ? (
                                                                    <p>
                                                                        {paymentInfoState.name && (
                                                                            <span>
                                                                                {paymentInfoState.name}
                                                                                <br />
                                                                            </span>
                                                                        )}
                                                                        {paymentInfoState.address.addressline1 && (
                                                                            <span>
                                                                                {paymentInfoState.address.addressline1}
                                                                                <br />
                                                                            </span>
                                                                        )}
                                                                        {paymentInfoState.address.addressline2 && (
                                                                            <span>
                                                                                {paymentInfoState.address.addressline2}
                                                                                <br />
                                                                            </span>
                                                                        )}
                                                                        <span>
                                                                            {[
                                                                                paymentInfoState.address.city,
                                                                                [paymentInfoState.address.state, paymentInfoState.address.zipCode].join(" "),
                                                                            ].join(", ")}
                                                                            <br />
                                                                        </span>
                                                                        <span className="dialog-icon">
                                                                            <em
                                                                                className={
                                                                                    "las " +
                                                                                    (paymentInfoState.paymentMethod === "CC"
                                                                                        ? "la-credit-card "
                                                                                        : "la-university ") +
                                                                                    "inline-icon"
                                                                                }
                                                                            ></em>{" "}
                                                                            {paymentInfoState.cardOrAccNumber}
                                                                            <br />
                                                                        </span>
                                                                        {paymentInfoState.exp && (
                                                                            <span>
                                                                                {" "}
                                                                                Exp. {paymentInfoState.exp}
                                                                                <br />{" "}
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                ) : (
                                                                    <div className="msg-generic msg-small margin-top-xs">
                                                                        <RenderIcons iconName="info-circle" />
                                                                        There is no Payment Profile
                                                                        <br />
                                                                        associated with your account.
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                                <span
                                                                    className="default_link"
                                                                    onClick={(e) => {
                                                                        showBillingInformation(e);
                                                                        window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                                    }}
                                                                >
                                                                    <a href="javascript:void(0)" className="default_link">
                                                                        {paymentInfoState.cardOrAccNumber ? "Change" : "Add"}
                                                                    </a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {!paymentInfoState.paymentMethod && (
                                                        <div className="data-value">
                                                            <input
                                                                type="text"
                                                                name="paymentMethod"
                                                                id="label-payment-method"
                                                                defaultValue={paymentInfoState.paymentMethod}
                                                                ref={register({ required: true })}
                                                                style={{ opacity: 0, height: 0, width: 0, float: "left" }}
                                                            />
                                                            {errors["paymentMethod"] && errors["paymentMethod"].type === "required" && (
                                                                <span className="form-error">Payment information is required</span>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className={loadingPaymentDetails ? "loading" : ""}>
                                        <div className="form-row data-grid has-lines row-height-sm">
                                            <fieldset className="form-row inline">
                                                <div className="row data-row">
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                        <div className="data-label" id="label-current-charge">
                                                            <strong>Plan Cost</strong>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value" aria-labelledby="label-current-charge">
                                                            ${paymentDetail.packagePrice ? Number(paymentDetail.packagePrice).toFixed(2) : "0.00"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset className="form-row inline">
                                                <div className="row data-row">
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                        <div className="data-label" id="label-monthly-charge">
                                                            <strong>
                                                                Family Protection X{" "}
                                                                {paymentDetail.countOfUserPaidFamilyMembers ? paymentDetail.countOfUserPaidFamilyMembers : "0"}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value" aria-labelledby="label-monthly-charge">
                                                            $
                                                            {paymentDetail.familyProtectionCharge
                                                                ? Number(paymentDetail.familyProtectionCharge).toFixed(2)
                                                                : "0.00"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            {paymentDetail.tax && (
                                                <fieldset className="form-row inline">
                                                    <div className="row data-row">
                                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                            <div className="data-label" id="label-difference">
                                                                <strong>Sales Tax</strong>
                                                            </div>
                                                        </div>
                                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby="label-difference">
                                                                ${paymentDetail.tax > 0 ? Number(paymentDetail.tax).toFixed(2) : "0.00"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            )}
                                            <fieldset className="form-row inline">
                                                <div className="row data-row">
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                        <div className="data-label" id="label-difference">
                                                            <strong>Total Cost</strong>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value" aria-labelledby="label-difference">
                                                            ${paymentDetail.totalCost ? Number(paymentDetail.totalCost).toFixed(2) : "0.00"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div className="form-row data-grid row-height-sm">
                                            <fieldset className="form-row inline">
                                                <div className="row data-row">
                                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                        <div className="data-label" id="label-todays-charge">
                                                            <h4 className="status-good">Today's Net Charge</h4>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                        <div className="data-value" aria-labelledby="label-todays-charge">
                                                            <div className="row between-xs">
                                                                <div className="col-xs col-no-gutter flex-grow-null">
                                                                    <h4 className="status-good">
                                                                        ${paymentDetail.todaysNetCharge ? Number(paymentDetail.todaysNetCharge).toFixed(2) : "0.00"}
                                                                    </h4>
                                                                </div>
                                                                {paymentDetail &&
                                                                    householdMembers &&
                                                                    (householdMembers.length > 1 || paymentDetail.packagePrice > 0) && (
                                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                                            <button
                                                                                aria-expanded="false"
                                                                                type="button"
                                                                                className="btn-default btn-toggle btn-no-padding"
                                                                                id="btn_calculation_rule"
                                                                                onClick={() => toggle("calculation_rule", "btn_calculation_rule")}
                                                                            >
                                                                                <span className="btn-toggle-status sr-only">Show</span>
                                                                                <span className="btn-text">How is this calculated?</span>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                            <div id="calculation_rule" style={{ display: "none" }}>
                                                                <br />
                                                                <p>{parse(paymentDetail.billingCycleDescription1)}</p>
                                                                <p>{parse(paymentDetail.billingCycleDescription2)}</p>
                                                                <p>{parse(paymentDetail.billingCycleDescription3)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="msg-generic">
                                        <div className="margin-bottom-l"></div>
                                        <h2 className="automatic-renewal"> {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.yearly-automatic-renewal") : tLang("registration.billing.renewal-disclosure.monthly-automatic-renewal")}</h2>
                                        <div className="margin-bottom-l"></div>
                                        <div className="form-row data-grid">
                                            <div className="form-input">
                                                <label className="form-checkbox-label" htmlFor="isAgreed">
                                                    <input type="checkbox" id="isAgreed" name="isAgreed" onChange={toggleDisableButton} onClick={storeTimestampCheckbox} ref={register({ required: true })} />
                                                    <span className="form-checkbox-label-text" style={{ paddingTop: "0.3rem" }}>
                                                        {tLang("registration.billing.renewal-disclosure.renewalText1")}
                                                        {paymentDetail.totalCost ? Number(paymentDetail.totalCost).toFixed(2) : "0.00"} {tLang("registration.billing.renewal-disclosure.renewalText2")} {" "} {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.an-annual") : tLang("registration.billing.renewal-disclosure.a-monthly")}{" "}
                                                        {tLang("registration.billing.renewal-disclosure.renewalText3")}
                                                        {paymentDetail.totalCost ? Number(paymentDetail.totalCost).toFixed(2) : "0.00"} {tLang("registration.billing.renewal-disclosure.renewalText4")} {" "}
                                                        {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {" "}
                                                        {tLang("registration.billing.renewal-disclosure.renewalText5")} {" "}
                                                        {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.annual") : tLang("registration.billing.renewal-disclosure.monthly")} {tLang("registration.billing.renewal-disclosure.renewalText6")} {" "} {getSubscriptionType() === "YEARLY" ? "date " : "day "}
                                                        {tLang("registration.billing.renewal-disclosure.renewalText7")} {" "}
                                                        {getSubscriptionType() === "YEARLY" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {tLang("registration.billing.renewal-disclosure.renewalText8")} {" "}
                                                        <div className="margin-bottom-l"></div>
                                                        <legend className="legend-label">{tLang("registration.billing.renewal-disclosure.cancellation")}</legend>
                                                        {tLang("registration.billing.renewal-disclosure.renewalText9")} {" "} {retailerTollFreeNumber ? retailerTollFreeNumber : partnerPhoneNumber}.

                                                        {tLang("registration.billing.renewal-disclosure.renewalText10")} {" "}
                                                       
                                                            <div className="margin-bottom-l"></div>
                                                            {tLang("registration.billing.terms-of-Use.terms-Text2")}{" "}
                                                        <span className="default_link">                                                         
                                                            {hasSontiqBrand ? (
                                                                <a href="https://www.sontiq.com/terms-of-use/" target="_blank" rel="noreferrer">
                                                                    Terms of Use
                                                                </a>
                                                            ) : (
                                                                <a
                                                                    href={getTermsOfUseURL()}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    onClick={(e) => {
                                                                        window.addToDataLayer({ event: "Pay as you go add adult family member - Show TNC" });
                                                                    }}
                                                                >
                                                                    Terms of Use
                                                                </a>
                                                            )}{" "}
                                                            and{" "}
                                                            <a href={getPrivacyNoticeURL()} target="_blank" rel="noreferrer">
                                                                Privacy Notice
                                                            </a>
                                                           .
                                                            </span>                                                  
                                                    </span>
                                                    {errors["billingAddress"] && <span className="form-error">{errors.billingAddress.message}</span>}
                                                    {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                                        <span className="form-error">You must agree to the terms and conditions.</span>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                        {paymentInfoState.paymentMethod === "EFT" && (
                                            <div className="form-row data-grid">
                                                <div className="form-input">
                                                    <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                                        <input
                                                            type="checkbox"
                                                            id="isEFTChecked"
                                                            name="isEFTChecked"
                                                            ref={register({ required: true })}
                                                            onChange={() => checked()}
                                                        />
                                                        <span className="form-checkbox-label-text">
                                                            I
                                                            <span
                                                                className="default_link"
                                                                onClick={() => {
                                                                    setEFTDialog(true);
                                                                    window.addToDataLayer({ event: "Protection Plan - EFT Acknowledgement" });
                                                                }}
                                                            >
                                                                &nbsp;
                                                                <a href="#" onClick={(e) => e.preventDefault()} className="default_link">
                                                                    authorize the use
                                                                </a>
                                                                &nbsp;
                                                            </span>
                                                            of my bank account information
                                                        </span>

                                                        {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                                            <span className="form-error">
                                                                You must authorize the use of your bank account information to continue.
                                                            </span>
                                                        )}
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="dialog-footer">
                                    <div className="row between-xs">
                                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            <button
                                                type="submit"
                                                className="btn-default btn-primary"
                                                id="btn-submit-purchase"
                                                disabled={loadingPaymentInfo || loadingPaymentDetails || disableButton}
                                                onClick={storeTimestampContinueButton}
                                            >
                                                <span className="btn-text">Purchase</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </React.Fragment>
                    )}
                </>
            ) : (
                <div className="box loading"></div>
            )}
            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="pay-as-you-go-billing-information-dialog"
                    title="Billing Information"
                    datalayerEvent="Pay As You Go - Close billing info"
                    closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }}
                >
                    <ProtectionPlanBillingInfo
                        dialogId="pay-as-you-go-billing-information-dialog"
                        setBillingInfoChanged={setBillingInfoChanged}
                        closeDialog={() => {
                            handleBillingCloseDialog("close");
                        }}
                        getSubscriptionType={getSubscriptionType}
                        selectedPackage={activePackage}
                    ></ProtectionPlanBillingInfo>
                </DialogComponent>
            )}
            {EFTdialog && (
                <DialogComponent dialogId="whatsIncluded" hideCloseButton={true} title="Your cart" closeDialog={handleCloseEFTDialog}>
                    <EFTDialog data={state.EFTData} closeDialog={handleCloseEFTDialog}></EFTDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default EZSAddFamilyMemberDialog;
